module.exports = __webpack_public_path__ + "img/message-sent-concept-illustration_114360-3363.2172940e.jpg";